// extracted by mini-css-extract-plugin
export default {"container":"CPI_container__9X1RV"};